<template>
  <ExhibitionContainer
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
  >
    <template slot="banner">
      <Banner
        booth-number="Building ABC, Level 1 - C14492"
      />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/modex-2026-banner';

export default {
  name: 'Modex2026',
  components: {
    Banner,
    ExhibitionContainer,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: process.env.VUE_APP_HUBSPOT_FORM_ID,
        portalId: process.env.VUE_APP_HUBSPOT_PORTAL_ID,
        region: process.env.VUE_APP_HUBSPOT_REGION,
      };
    },
  },
};
</script>
